module.exports = {"amount":"aantal","currency":"valuta","length":"lengte","mass":"gewicht","temperature":"temperatuur","time":"tijd","volume":"inhoud"}